import Vue from 'vue'
import UITips from './Tips.vue'
import UIAlert from './Alert.vue'
import UIConfirm from './Confirm.vue'
import UILoading from './Loading.vue'
import UIBroadcast from './Broadcast.vue'
import UIMessage from './Message.vue'
import UIIntroduce from './Introduce.vue'




const Tips = Vue.extend(UITips)
const Alert = Vue.extend(UIAlert)
const Confirm = Vue.extend(UIConfirm)
const Loading = Vue.extend(UILoading)
const Broadcast = Vue.extend(UIBroadcast)
const Message = Vue.extend(UIMessage)
const Introduce = Vue.extend(UIIntroduce)




export function $tips(data={}) {
    let instance = new Tips({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export function $alert(data={}) {
    let instance = new Alert({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export function $confirm(data={}) {
    let instance = new Confirm({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export function $message(data={}) {
    let instance = new Message({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}
export function $introduce(data={}) {
    let instance = new Introduce({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

let loadingInstance = ''
export function $showLoading(data={}) {
    if (loadingInstance) {
        return
    }
    loadingInstance = new Loading({
        data
    }).$mount()

    document.body.appendChild(loadingInstance.$el)

    Vue.nextTick(() => {
        loadingInstance.show = true
    })
}

export function $hideLoading() {
    if (loadingInstance) {
        document.body.removeChild(loadingInstance.$el)
        loadingInstance = ''
    }
}



let broadcastInstance = ''
export function $showBroadcast(data={}) {
    if (broadcastInstance) {
        return
    }
    broadcastInstance = new Broadcast({
        data
    }).$mount()

    document.body.appendChild(broadcastInstance.$el)

    Vue.nextTick(() => {
        broadcastInstance.show = true
    })
}

export function $hideBroadcast() {
    if (broadcastInstance) {
        document.body.removeChild(broadcastInstance.$el)
        broadcastInstance = ''
    }
}
